[
  {
    "code": "CL-VS-ALG",
    "name": "Algarrobo"
  },
  {
    "code": "CL-RM-ALH",
    "name": "Alhué"
  },
  {
    "code": "CL-BI-ALT",
    "name": "Alto Biobío"
  },
  {
    "code": "CL-AT-ALT",
    "name": "Alto del Carmen"
  },
  {
    "code": "CL-TA-ALT",
    "name": "Alto Hospicio"
  },
  {
    "code": "CL-LL-ANC",
    "name": "Ancud"
  },
  {
    "code": "CL-CO-AND",
    "name": "Andacollo"
  },
  {
    "code": "CL-AR-ANG",
    "name": "Angol"
  },
  {
    "code": "CL-AN-ANT",
    "name": "Antofagasta"
  },
  {
    "code": "CL-BI-ANT",
    "name": "Antuco"
  },
  {
    "code": "CL-BI-ARA",
    "name": "Arauco"
  },
  {
    "code": "CL-AP-ARI",
    "name": "Arica"
  },
  {
    "code": "CL-AI-AYS",
    "name": "Aysén"
  },
  {
    "code": "CL-RM-BUI",
    "name": "Buin"
  },
  {
    "code": "CL-NB-BUL",
    "name": "Bulnes"
  },
  {
    "code": "CL-VS-CAB",
    "name": "Cabildo"
  },
  {
    "code": "CL-MA-CAB",
    "name": "Cabo de Hornos"
  },
  {
    "code": "CL-BI-CAB",
    "name": "Cabrero"
  },
  {
    "code": "CL-AN-CAL",
    "name": "Calama"
  },
  {
    "code": "CL-LL-CAL",
    "name": "Calbuco"
  },
  {
    "code": "CL-AT-CAL",
    "name": "Caldera"
  },
  {
    "code": "CL-VS-CAL",
    "name": "Calera"
  },
  {
    "code": "CL-RM-CAL",
    "name": "Calera de Tango"
  },
  {
    "code": "CL-VS-CLA",
    "name": "Calle Larga"
  },
  {
    "code": "CL-AP-CAM",
    "name": "Camarones"
  },
  {
    "code": "CL-TA-CAM",
    "name": "Camiña"
  },
  {
    "code": "CL-CO-CAN",
    "name": "Canela"
  },
  {
    "code": "CL-AR-CAR",
    "name": "Carahue"
  },
  {
    "code": "CL-VS-CAR",
    "name": "Cartagena"
  },
  {
    "code": "CL-VS-CAS",
    "name": "Casablanca"
  },
  {
    "code": "CL-LL-CAS",
    "name": "Castro"
  },
  {
    "code": "CL-VS-CAT",
    "name": "Catemu"
  },
  {
    "code": "CL-ML-CAU",
    "name": "Cauquenes"
  },
  {
    "code": "CL-BI-CAN",
    "name": "Cañete"
  },
  {
    "code": "CL-RM-CER",
    "name": "Cerrillos"
  },
  {
    "code": "CL-RM-CNA",
    "name": "Cerro Navia"
  },
  {
    "code": "CL-LL-CHA",
    "name": "Chaitén"
  },
  {
    "code": "CL-ML-CHA",
    "name": "Chanco"
  },
  {
    "code": "CL-AT-CHA",
    "name": "Chañaral"
  },
  {
    "code": "CL-BI-CGU",
    "name": "Chiguayante"
  },
  {
    "code": "CL-AI-CLE",
    "name": "Chile Chico"
  },
  {
    "code": "CL-NB-CLL",
    "name": "Chillán"
  },
  {
    "code": "CL-NB-CVI",
    "name": "Chillán Viejo"
  },
  {
    "code": "CL-LI-CMB",
    "name": "Chimbarongo"
  },
  {
    "code": "CL-AR-CHO",
    "name": "Cholchol"
  },
  {
    "code": "CL-LL-CHO",
    "name": "Chonchi"
  },
  {
    "code": "CL-LI-CHE",
    "name": "Chépica"
  },
  {
    "code": "CL-AI-CIS",
    "name": "Cisnes"
  },
  {
    "code": "CL-NB-COB",
    "name": "Cobquecura"
  },
  {
    "code": "CL-LL-COC",
    "name": "Cochamó"
  },
  {
    "code": "CL-AI-COC",
    "name": "Cochrane"
  },
  {
    "code": "CL-LI-COD",
    "name": "Codegua"
  },
  {
    "code": "CL-NB-COE",
    "name": "Coelemu"
  },
  {
    "code": "CL-NB-COI",
    "name": "Coihueco"
  },
  {
    "code": "CL-LI-COI",
    "name": "Coinco"
  },
  {
    "code": "CL-ML-COL",
    "name": "Colbún"
  },
  {
    "code": "CL-TA-COL",
    "name": "Colchane"
  },
  {
    "code": "CL-RM-COL",
    "name": "Colina"
  },
  {
    "code": "CL-AR-COL",
    "name": "Collipulli"
  },
  {
    "code": "CL-LI-COL",
    "name": "Coltauco"
  },
  {
    "code": "CL-CO-COM",
    "name": "Combarbalá"
  },
  {
    "code": "CL-BI-CCE",
    "name": "Concepción"
  },
  {
    "code": "CL-RM-CON",
    "name": "Conchalí"
  },
  {
    "code": "CL-VS-CON",
    "name": "Concón"
  },
  {
    "code": "CL-ML-CON",
    "name": "Constitución"
  },
  {
    "code": "CL-BI-CTU",
    "name": "Contulmo"
  },
  {
    "code": "CL-AT-COP",
    "name": "Copiapó"
  },
  {
    "code": "CL-CO-COQ",
    "name": "Coquimbo"
  },
  {
    "code": "CL-BI-COR",
    "name": "Coronel"
  },
  {
    "code": "CL-LR-COR",
    "name": "Corral"
  },
  {
    "code": "CL-AI-COY",
    "name": "Coyhaique"
  },
  {
    "code": "CL-AR-CUN",
    "name": "Cunco"
  },
  {
    "code": "CL-AR-CAC",
    "name": "Curacautín"
  },
  {
    "code": "CL-RM-CUR",
    "name": "Curacaví"
  },
  {
    "code": "CL-LL-CUR",
    "name": "Curaco de Vélez"
  },
  {
    "code": "CL-BI-CUR",
    "name": "Curanilahue"
  },
  {
    "code": "CL-AR-CUR",
    "name": "Curarrehue"
  },
  {
    "code": "CL-ML-CEP",
    "name": "Curepto"
  },
  {
    "code": "CL-ML-CIC",
    "name": "Curicó"
  },
  {
    "code": "CL-LL-DAL",
    "name": "Dalcahue"
  },
  {
    "code": "CL-AT-DIE",
    "name": "Diego de Almagro"
  },
  {
    "code": "CL-LI-DON",
    "name": "Doñihue"
  },
  {
    "code": "CL-RM-ELB",
    "name": "El Bosque"
  },
  {
    "code": "CL-NB-ELC",
    "name": "El Carmen"
  },
  {
    "code": "CL-RM-ELM",
    "name": "El Monte"
  },
  {
    "code": "CL-VS-ELQ",
    "name": "El Quisco"
  },
  {
    "code": "CL-VS-ELT",
    "name": "El Tabo"
  },
  {
    "code": "CL-ML-EMP",
    "name": "Empedrado"
  },
  {
    "code": "CL-AR-ERC",
    "name": "Ercilla"
  },
  {
    "code": "CL-RM-EST",
    "name": "Estación Central"
  },
  {
    "code": "CL-BI-FLO",
    "name": "Florida"
  },
  {
    "code": "CL-AR-FRE",
    "name": "Freire"
  },
  {
    "code": "CL-AT-FRE",
    "name": "Freirina"
  },
  {
    "code": "CL-LL-FRE",
    "name": "Fresia"
  },
  {
    "code": "CL-LL-FRU",
    "name": "Frutillar"
  },
  {
    "code": "CL-LL-FUT",
    "name": "Futaleufú"
  },
  {
    "code": "CL-LR-FUT",
    "name": "Futrono"
  },
  {
    "code": "CL-AR-GAL",
    "name": "Galvarino"
  },
  {
    "code": "CL-AP-GEN",
    "name": "General Lagos"
  },
  {
    "code": "CL-AR-GOR",
    "name": "Gorbea"
  },
  {
    "code": "CL-LI-GRA",
    "name": "Graneros"
  },
  {
    "code": "CL-AI-GUA",
    "name": "Guaitecas"
  },
  {
    "code": "CL-VS-HIJ",
    "name": "Hijuelas"
  },
  {
    "code": "CL-LL-HUA",
    "name": "Hualaihué"
  },
  {
    "code": "CL-ML-HUA",
    "name": "Hualañé"
  },
  {
    "code": "CL-BI-HPE",
    "name": "Hualpén"
  },
  {
    "code": "CL-BI-HQU",
    "name": "Hualqui"
  },
  {
    "code": "CL-TA-HUA",
    "name": "Huara"
  },
  {
    "code": "CL-AT-HUA",
    "name": "Huasco"
  },
  {
    "code": "CL-RM-HUE",
    "name": "Huechuraba"
  },
  {
    "code": "CL-CO-ILL",
    "name": "Illapel"
  },
  {
    "code": "CL-RM-IND",
    "name": "Independencia"
  },
  {
    "code": "CL-TA-IQU",
    "name": "Iquique"
  },
  {
    "code": "CL-RM-ISL",
    "name": "Isla de Maipo"
  },
  {
    "code": "CL-VS-ISL",
    "name": "Isla de Pascua"
  },
  {
    "code": "CL-VS-JUA",
    "name": "Juan Fernández"
  },
  {
    "code": "CL-RM-LAC",
    "name": "La Cisterna"
  },
  {
    "code": "CL-VS-LAC",
    "name": "La Cruz"
  },
  {
    "code": "CL-LI-LAE",
    "name": "La Estrella"
  },
  {
    "code": "CL-RM-LAF",
    "name": "La Florida"
  },
  {
    "code": "CL-RM-LAG",
    "name": "La Granja"
  },
  {
    "code": "CL-CO-LAH",
    "name": "La Higuera"
  },
  {
    "code": "CL-VS-LAL",
    "name": "La Ligua"
  },
  {
    "code": "CL-RM-LAP",
    "name": "La Pintana"
  },
  {
    "code": "CL-RM-LAR",
    "name": "La Reina"
  },
  {
    "code": "CL-CO-LAS",
    "name": "La Serena"
  },
  {
    "code": "CL-LR-LAU",
    "name": "La Unión"
  },
  {
    "code": "CL-LR-RAN",
    "name": "Lago Ranco"
  },
  {
    "code": "CL-AI-VER",
    "name": "Lago Verde"
  },
  {
    "code": "CL-MA-LAG",
    "name": "Laguna Blanca"
  },
  {
    "code": "CL-BI-LAJ",
    "name": "Laja"
  },
  {
    "code": "CL-RM-LAM",
    "name": "Lampa"
  },
  {
    "code": "CL-LR-LAN",
    "name": "Lanco"
  },
  {
    "code": "CL-LI-LAS",
    "name": "Las Cabras"
  },
  {
    "code": "CL-RM-LAS",
    "name": "Las Condes"
  },
  {
    "code": "CL-AR-LAU",
    "name": "Lautaro"
  },
  {
    "code": "CL-BI-LEB",
    "name": "Lebu"
  },
  {
    "code": "CL-ML-LIC",
    "name": "Licantén"
  },
  {
    "code": "CL-VS-LIM",
    "name": "Limache"
  },
  {
    "code": "CL-ML-LIN",
    "name": "Linares"
  },
  {
    "code": "CL-LI-LIT",
    "name": "Litueche"
  },
  {
    "code": "CL-VS-LLA",
    "name": "Llaillay"
  },
  {
    "code": "CL-LL-LLA",
    "name": "Llanquihue"
  },
  {
    "code": "CL-RM-LOB",
    "name": "Lo Barnechea"
  },
  {
    "code": "CL-RM-LOE",
    "name": "Lo Espejo"
  },
  {
    "code": "CL-RM-LOP",
    "name": "Lo Prado"
  },
  {
    "code": "CL-LI-LOL",
    "name": "Lolol"
  },
  {
    "code": "CL-AR-LCO",
    "name": "Loncoche"
  },
  {
    "code": "CL-ML-LON",
    "name": "Longaví"
  },
  {
    "code": "CL-AR-LQU",
    "name": "Lonquimay"
  },
  {
    "code": "CL-BI-ALA",
    "name": "Los Alamos"
  },
  {
    "code": "CL-VS-AND",
    "name": "Los Andes"
  },
  {
    "code": "CL-BI-ANG",
    "name": "Los Angeles"
  },
  {
    "code": "CL-LR-LAG",
    "name": "Los Lagos"
  },
  {
    "code": "CL-LL-MUE",
    "name": "Los Muermos"
  },
  {
    "code": "CL-AR-SAU",
    "name": "Los Sauces"
  },
  {
    "code": "CL-CO-VIL",
    "name": "Los Vilos"
  },
  {
    "code": "CL-BI-LOT",
    "name": "Lota"
  },
  {
    "code": "CL-AR-LUM",
    "name": "Lumaco"
  },
  {
    "code": "CL-LI-MAC",
    "name": "Machalí"
  },
  {
    "code": "CL-RM-MAC",
    "name": "Macul"
  },
  {
    "code": "CL-RM-MAI",
    "name": "Maipú"
  },
  {
    "code": "CL-LI-MAL",
    "name": "Malloa"
  },
  {
    "code": "CL-LI-MAR",
    "name": "Marchigüe"
  },
  {
    "code": "CL-LR-MAR",
    "name": "Mariquina"
  },
  {
    "code": "CL-AN-MAR",
    "name": "María Elena"
  },
  {
    "code": "CL-RM-MAR",
    "name": "María Pinto"
  },
  {
    "code": "CL-ML-MAU",
    "name": "Maule"
  },
  {
    "code": "CL-LL-MAU",
    "name": "Maullín"
  },
  {
    "code": "CL-AN-MEJ",
    "name": "Mejillones"
  },
  {
    "code": "CL-AR-MEL",
    "name": "Melipeuco"
  },
  {
    "code": "CL-RM-MEL",
    "name": "Melipilla"
  },
  {
    "code": "CL-ML-MOL",
    "name": "Molina"
  },
  {
    "code": "CL-CO-MON",
    "name": "Monte Patria"
  },
  {
    "code": "CL-LI-MOS",
    "name": "Mostazal"
  },
  {
    "code": "CL-BI-MUL",
    "name": "Mulchén"
  },
  {
    "code": "CL-LR-MAF",
    "name": "Máfil"
  },
  {
    "code": "CL-BI-NAC",
    "name": "Nacimiento"
  },
  {
    "code": "CL-LI-NAN",
    "name": "Nancagua"
  },
  {
    "code": "CL-MA-NAT",
    "name": "Natales"
  },
  {
    "code": "CL-LI-NAV",
    "name": "Navidad"
  },
  {
    "code": "CL-BI-NEG",
    "name": "Negrete"
  },
  {
    "code": "CL-NB-NIN",
    "name": "Ninhue"
  },
  {
    "code": "CL-VS-NOG",
    "name": "Nogales"
  },
  {
    "code": "CL-AR-NUE",
    "name": "Nueva Imperial"
  },
  {
    "code": "CL-AI-OHI",
    "name": "O'Higgins"
  },
  {
    "code": "CL-LI-OLI",
    "name": "Olivar"
  },
  {
    "code": "CL-AN-OLL",
    "name": "Ollagüe"
  },
  {
    "code": "CL-VS-OLM",
    "name": "Olmué"
  },
  {
    "code": "CL-LL-OSO",
    "name": "Osorno"
  },
  {
    "code": "CL-CO-OVA",
    "name": "Ovalle"
  },
  {
    "code": "CL-RM-PAD",
    "name": "Padre Hurtado"
  },
  {
    "code": "CL-AR-PAD",
    "name": "Padre Las Casas"
  },
  {
    "code": "CL-CO-PAI",
    "name": "Paihuano"
  },
  {
    "code": "CL-LR-PAI",
    "name": "Paillaco"
  },
  {
    "code": "CL-RM-PAI",
    "name": "Paine"
  },
  {
    "code": "CL-LL-PAL",
    "name": "Palena"
  },
  {
    "code": "CL-LI-PAL",
    "name": "Palmilla"
  },
  {
    "code": "CL-LR-PAN",
    "name": "Panguipulli"
  },
  {
    "code": "CL-VS-PAN",
    "name": "Panquehue"
  },
  {
    "code": "CL-VS-PAP",
    "name": "Papudo"
  },
  {
    "code": "CL-LI-PAR",
    "name": "Paredones"
  },
  {
    "code": "CL-ML-PAR",
    "name": "Parral"
  },
  {
    "code": "CL-RM-PAC",
    "name": "Pedro Aguirre Cerda"
  },
  {
    "code": "CL-ML-PEL",
    "name": "Pelarco"
  },
  {
    "code": "CL-ML-PLU",
    "name": "Pelluhue"
  },
  {
    "code": "CL-NB-PEM",
    "name": "Pemuco"
  },
  {
    "code": "CL-ML-PEN",
    "name": "Pencahue"
  },
  {
    "code": "CL-BI-PEN",
    "name": "Penco"
  },
  {
    "code": "CL-LI-PER",
    "name": "Peralillo"
  },
  {
    "code": "CL-AR-PER",
    "name": "Perquenco"
  },
  {
    "code": "CL-VS-PET",
    "name": "Petorca"
  },
  {
    "code": "CL-LI-PEU",
    "name": "Peumo"
  },
  {
    "code": "CL-RM-PFL",
    "name": "Peñaflor"
  },
  {
    "code": "CL-RM-PLO",
    "name": "Peñalolén"
  },
  {
    "code": "CL-TA-PIC",
    "name": "Pica"
  },
  {
    "code": "CL-LI-PDE",
    "name": "Pichidegua"
  },
  {
    "code": "CL-LI-PLE",
    "name": "Pichilemu"
  },
  {
    "code": "CL-NB-PIN",
    "name": "Pinto"
  },
  {
    "code": "CL-RM-PIR",
    "name": "Pirque"
  },
  {
    "code": "CL-AR-PIT",
    "name": "Pitrufquén"
  },
  {
    "code": "CL-LI-PLA",
    "name": "Placilla"
  },
  {
    "code": "CL-NB-POR",
    "name": "Portezuelo"
  },
  {
    "code": "CL-MA-POR",
    "name": "Porvenir"
  },
  {
    "code": "CL-TA-POZ",
    "name": "Pozo Almonte"
  },
  {
    "code": "CL-MA-PRI",
    "name": "Primavera"
  },
  {
    "code": "CL-RM-PRO",
    "name": "Providencia"
  },
  {
    "code": "CL-VS-PUC",
    "name": "Puchuncaví"
  },
  {
    "code": "CL-AR-PUC",
    "name": "Pucón"
  },
  {
    "code": "CL-RM-PUD",
    "name": "Pudahuel"
  },
  {
    "code": "CL-RM-PUE",
    "name": "Puente Alto"
  },
  {
    "code": "CL-LL-OMO",
    "name": "Puerto Montt"
  },
  {
    "code": "CL-LL-OOC",
    "name": "Puerto Octay"
  },
  {
    "code": "CL-LL-OVA",
    "name": "Puerto Varas"
  },
  {
    "code": "CL-LI-PUM",
    "name": "Pumanque"
  },
  {
    "code": "CL-CO-PUN",
    "name": "Punitaqui"
  },
  {
    "code": "CL-MA-PUN",
    "name": "Punta Arenas"
  },
  {
    "code": "CL-LL-PUQ",
    "name": "Puqueldón"
  },
  {
    "code": "CL-LL-PUR",
    "name": "Purranque"
  },
  {
    "code": "CL-AR-PUR",
    "name": "Purén"
  },
  {
    "code": "CL-VS-PUT",
    "name": "Putaendo"
  },
  {
    "code": "CL-AP-PUT",
    "name": "Putre"
  },
  {
    "code": "CL-LL-PUY",
    "name": "Puyehue"
  },
  {
    "code": "CL-LL-QIL",
    "name": "Queilén"
  },
  {
    "code": "CL-LL-QLL",
    "name": "Quellón"
  },
  {
    "code": "CL-LL-QMC",
    "name": "Quemchi"
  },
  {
    "code": "CL-BI-QLA",
    "name": "Quilaco"
  },
  {
    "code": "CL-RM-QLI",
    "name": "Quilicura"
  },
  {
    "code": "CL-BI-QEC",
    "name": "Quilleco"
  },
  {
    "code": "CL-VS-QOT",
    "name": "Quillota"
  },
  {
    "code": "CL-NB-QON",
    "name": "Quillón"
  },
  {
    "code": "CL-VS-QLP",
    "name": "Quilpué"
  },
  {
    "code": "CL-LL-QNC",
    "name": "Quinchao"
  },
  {
    "code": "CL-LI-QNT",
    "name": "Quinta de Tilcoco"
  },
  {
    "code": "CL-RM-QNT",
    "name": "Quinta Normal"
  },
  {
    "code": "CL-VS-QNT",
    "name": "Quintero"
  },
  {
    "code": "CL-NB-QRI",
    "name": "Quirihue"
  },
  {
    "code": "CL-LI-RAN",
    "name": "Rancagua"
  },
  {
    "code": "CL-ML-RAU",
    "name": "Rauco"
  },
  {
    "code": "CL-RM-REC",
    "name": "Recoleta"
  },
  {
    "code": "CL-AR-REN",
    "name": "Renaico"
  },
  {
    "code": "CL-RM-REN",
    "name": "Renca"
  },
  {
    "code": "CL-LI-REN",
    "name": "Rengo"
  },
  {
    "code": "CL-LI-REQ",
    "name": "Requínoa"
  },
  {
    "code": "CL-ML-RET",
    "name": "Retiro"
  },
  {
    "code": "CL-VS-RIN",
    "name": "Rinconada"
  },
  {
    "code": "CL-ML-ROM",
    "name": "Romeral"
  },
  {
    "code": "CL-NB-RAN",
    "name": "Ránquil"
  },
  {
    "code": "CL-LR-RIO",
    "name": "Río Bueno"
  },
  {
    "code": "CL-ML-RIO",
    "name": "Río Claro"
  },
  {
    "code": "CL-CO-RIO",
    "name": "Río Hurtado"
  },
  {
    "code": "CL-AI-RIO",
    "name": "Río Ibáñez"
  },
  {
    "code": "CL-LL-RIO",
    "name": "Río Negro"
  },
  {
    "code": "CL-MA-RIO",
    "name": "Río Verde"
  },
  {
    "code": "CL-AR-SAA",
    "name": "Saavedra"
  },
  {
    "code": "CL-ML-SAG",
    "name": "Sagrada Familia"
  },
  {
    "code": "CL-CO-SAL",
    "name": "Salamanca"
  },
  {
    "code": "CL-VS-ANT",
    "name": "San Antonio"
  },
  {
    "code": "CL-RM-BER",
    "name": "San Bernardo"
  },
  {
    "code": "CL-NB-CAR",
    "name": "San Carlos"
  },
  {
    "code": "CL-ML-CLE",
    "name": "San Clemente"
  },
  {
    "code": "CL-VS-EST",
    "name": "San Esteban"
  },
  {
    "code": "CL-NB-FAB",
    "name": "San Fabián"
  },
  {
    "code": "CL-VS-FEL",
    "name": "San Felipe"
  },
  {
    "code": "CL-LI-FER",
    "name": "San Fernando"
  },
  {
    "code": "CL-MA-GRE",
    "name": "San Gregorio"
  },
  {
    "code": "CL-NB-IGN",
    "name": "San Ignacio"
  },
  {
    "code": "CL-ML-JAV",
    "name": "San Javier"
  },
  {
    "code": "CL-RM-JOA",
    "name": "San Joaquín"
  },
  {
    "code": "CL-RM-JOS",
    "name": "San José de Maipo"
  },
  {
    "code": "CL-LL-JUA",
    "name": "San Juan de la Costa"
  },
  {
    "code": "CL-RM-MIG",
    "name": "San Miguel"
  },
  {
    "code": "CL-NB-NIC",
    "name": "San Nicolás"
  },
  {
    "code": "CL-LL-PAB",
    "name": "San Pablo"
  },
  {
    "code": "CL-RM-PED",
    "name": "San Pedro"
  },
  {
    "code": "CL-AN-PED",
    "name": "San Pedro de Atacama"
  },
  {
    "code": "CL-BI-PED",
    "name": "San Pedro de la Paz"
  },
  {
    "code": "CL-ML-RAF",
    "name": "San Rafael"
  },
  {
    "code": "CL-RM-RAM",
    "name": "San Ramón"
  },
  {
    "code": "CL-BI-ROS",
    "name": "San Rosendo"
  },
  {
    "code": "CL-LI-VIC",
    "name": "San Vicente"
  },
  {
    "code": "CL-BI-BAR",
    "name": "Santa Bárbara"
  },
  {
    "code": "CL-LI-CRU",
    "name": "Santa Cruz"
  },
  {
    "code": "CL-BI-JUA",
    "name": "Santa Juana"
  },
  {
    "code": "CL-VS-MAR",
    "name": "Santa María"
  },
  {
    "code": "CL-RM-SAN",
    "name": "Santiago"
  },
  {
    "code": "CL-VS-SAN",
    "name": "Santo Domingo"
  },
  {
    "code": "CL-AN-SIE",
    "name": "Sierra Gorda"
  },
  {
    "code": "CL-RM-TAL",
    "name": "Talagante"
  },
  {
    "code": "CL-ML-TAL",
    "name": "Talca"
  },
  {
    "code": "CL-BI-TAL",
    "name": "Talcahuano"
  },
  {
    "code": "CL-AN-TAL",
    "name": "Taltal"
  },
  {
    "code": "CL-AR-TEM",
    "name": "Temuco"
  },
  {
    "code": "CL-ML-TEN",
    "name": "Teno"
  },
  {
    "code": "CL-AR-TEO",
    "name": "Teodoro Schmidt"
  },
  {
    "code": "CL-AT-TIE",
    "name": "Tierra Amarilla"
  },
  {
    "code": "CL-RM-TIL",
    "name": "Tiltil"
  },
  {
    "code": "CL-MA-TIM",
    "name": "Timaukel"
  },
  {
    "code": "CL-BI-TIR",
    "name": "Tirúa"
  },
  {
    "code": "CL-AN-TOC",
    "name": "Tocopilla"
  },
  {
    "code": "CL-AR-TOL",
    "name": "Toltén"
  },
  {
    "code": "CL-BI-TOM",
    "name": "Tomé"
  },
  {
    "code": "CL-MA-TOR",
    "name": "Torres del Paine"
  },
  {
    "code": "CL-AI-TOR",
    "name": "Tortel"
  },
  {
    "code": "CL-AR-TRA",
    "name": "Traiguén"
  },
  {
    "code": "CL-NB-TRE",
    "name": "Treguaco"
  },
  {
    "code": "CL-BI-TUC",
    "name": "Tucapel"
  },
  {
    "code": "CL-LR-VAL",
    "name": "Valdivia"
  },
  {
    "code": "CL-AT-VAL",
    "name": "Vallenar"
  },
  {
    "code": "CL-VS-VAL",
    "name": "Valparaíso"
  },
  {
    "code": "CL-ML-VIC",
    "name": "Vichuquén"
  },
  {
    "code": "CL-AR-VIC",
    "name": "Victoria"
  },
  {
    "code": "CL-CO-VIC",
    "name": "Vicuña"
  },
  {
    "code": "CL-AR-VLC",
    "name": "Vilcún"
  },
  {
    "code": "CL-ML-VIL",
    "name": "Villa Alegre"
  },
  {
    "code": "CL-VS-VIL",
    "name": "Villa Alemana"
  },
  {
    "code": "CL-AR-VLA",
    "name": "Villarrica"
  },
  {
    "code": "CL-RM-VIT",
    "name": "Vitacura"
  },
  {
    "code": "CL-VS-VIN",
    "name": "Viña del Mar"
  },
  {
    "code": "CL-ML-YER",
    "name": "Yerbas Buenas"
  },
  {
    "code": "CL-BI-YUM",
    "name": "Yumbel"
  },
  {
    "code": "CL-NB-YUN",
    "name": "Yungay"
  },
  {
    "code": "CL-VS-ZAP",
    "name": "Zapallar"
  },
  {
    "code": "CL-NB-NIQ",
    "name": "Ñiquén"
  },
  {
    "code": "CL-RM-NUN",
    "name": "Ñuñoa"
  }
]